import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { commissionApi, UpdateCommissionData } from '../api/commissionApi'
import { frameTypeApi } from '../api/frameTypeApi'
import { sizeApi } from '../api/sizeApi'
import { useToast } from '@/hooks/use-toast'

export function useCommissions(artworkId: number) {
  return useQuery({
    queryKey: ['commissions', artworkId],
    queryFn: () => commissionApi.getCommissions(artworkId),
    enabled: !!artworkId,
  })
}

export function useUpdateCommission() {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: ({ artworkId, data }: { artworkId: number; data: UpdateCommissionData }) =>
      commissionApi.updateCommission(artworkId, data),
    onSuccess: (commissions, variables) => {
      queryClient.setQueryData(['commissions', variables.artworkId], commissions)
      toast({
        title: 'Saved',
        description: 'Commission updated',
      })
    },
    onError: () => {
      toast({
        title: 'Not saved',
        description: 'The commission could not be updated. Please try again.',
        variant: 'destructive',
      })
    },
  })
}

export function useFrameTypes() {
  return useQuery({
    queryKey: ['frameTypes'],
    queryFn: frameTypeApi.getAllFrameTypes,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
}

export function useSizes() {
  return useQuery({
    queryKey: ['sizes'],
    queryFn: sizeApi.getAllSizes,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
}

